import React from 'react';
import root from 'window-or-global';
import PropTypes from 'prop-types';
import {withRouter, Redirect} from 'react-router';
import semver from 'semver';
import classNames from 'classnames';
import {generateRoutePath} from 'epic-common/src/route';
import epicTracking from 'epic-tracking';
import AndroidDownloadNewFlow from './AndroidDownloadNewFlow';
import EGSDownloadImage from 'epic-react-common/src/components/EGSDownloadImage';
import {getLocale} from 'epic-common/src/locale';

class AndroidDownload extends React.Component {
    static propTypes = {
        data: PropTypes.object,
        isAndroid: PropTypes.bool,
        link: PropTypes.string,
        oldFlow: PropTypes.bool,
        newFlow: PropTypes.bool,
        notSupported: PropTypes.bool,
        osVersion: PropTypes.string,
        supportedDevices: PropTypes.object,
        location: PropTypes.object
    };

    state = {
        show: false
    };

    componentDidMount() {
        const {link, notSupported, isAndroid} = this.props;
        if (isAndroid && !notSupported) {
            setTimeout(() => {
                root.location = link;
            }, 1000);
        }
    }

    trackClick(title) {
        epicTracking.trackEvent('Interaction', {
            interactionType: 'click',
            eventCategory: 'fortnite Android',
            eventAction: 'Redownload',
            eventLabel: title
        });
    }

    onChange = title => {
        epicTracking.trackEvent('Interaction', {
            interactionType: 'click',
            eventCategory: 'fortnite Android',
            eventAction: 'Toggle Drawer',
            eventLabel: title
        });
        this.setState({show: !this.state.show});
    };

    render() {
        const {data, isAndroid, link, notSupported, oldFlow, newFlow, osVersion} = this.props;
        const locale = getLocale();
        const supportedDevices = this.props.supportedDevices || {};
        const location = this.props.location || {};
        const search = location.search || '';
        if (!isAndroid) {
            return (
                <Redirect
                    to={{
                        pathname: generateRoutePath('/mobile/android/get-started'),
                        search
                    }}
                />
            );
        } else if (semver.satisfies(semver.coerce(osVersion), '5.x.x - 7.x.x') && !oldFlow) {
            return (
                <Redirect
                    to={{
                        pathname: generateRoutePath('/mobile/android/old-device'),
                        search
                    }}
                />
            );
        } else if (semver.satisfies(semver.coerce(osVersion), '>=8.x.x') && !newFlow) {
            return (
                <Redirect
                    to={{
                        pathname: generateRoutePath('/mobile/android/new-device'),
                        search
                    }}
                />
            );
        } else if (semver.satisfies(semver.coerce(osVersion), '<5.x.x') && !notSupported) {
            return (
                <Redirect
                    to={{
                        pathname: generateRoutePath('/mobile/android/not-supported'),
                        search
                    }}
                />
            );
        }
        const settings = data.settingsMessage || [];
        const settingMessage = settings.map(item => {
            const osKey = item.osVersion;
            const semVersion = semver.valid(semver.coerce(osKey));
            if (semver.satisfies(semver.coerce(osVersion), '4.5.x - 4.9.x') && semver.satisfies(semVersion, '4.5.x - 4.9.x')) {
                return (
                    <div
                        className="settings-message text-left"
                        key={`item-${osKey}`}
                        dangerouslySetInnerHTML={{__html: item.description}}
                    />
                );
            } else if (semver.satisfies(semver.coerce(osVersion), '5.x.x - 5.9.x') && semver.satisfies(semVersion, '5.x.x - 5.9.x')) {
                return (
                    <div
                        className="settings-message text-left"
                        key={`item-${osKey}`}
                        dangerouslySetInnerHTML={{__html: item.description}}
                    />
                );
            } else if (semver.satisfies(semver.coerce(osVersion), '6.x.x - 6.9.x') && semver.satisfies(semVersion, '6.x.x - 6.9.x')) {
                return (
                    <div
                        className="settings-message text-left"
                        key={`item-${osKey}`}
                        dangerouslySetInnerHTML={{__html: item.description}}
                    />
                );
            } else if (semver.satisfies(semver.coerce(osVersion), '7.x.x - 7.9.x') && semver.satisfies(semVersion, '7.x.x - 7.9.x')) {
                return (
                    <div
                        className="settings-message text-left"
                        key={`item-${osKey}`}
                        dangerouslySetInnerHTML={{__html: item.description}}
                    />
                );
            }
            return <div key={`item-${osKey}`} />;
        });
        const linkCTA = notSupported ? generateRoutePath('/faq') : link;
        const buttonID = notSupported ? 'FAQ Button' : 'Redownload';
        const drawerClass = classNames('support', {active: this.state.show});
        const downloadClass = classNames('android-downloadpage', {newFlow, oldFlow, notSupported});

        return (
            <div className={downloadClass}>
                <div className="container-fluid">
                    {data.image ? (
                        <div className="row">
                            <div className="col-xs-12 text-center">
                                <img src={data.image} alt="Fortnite Icon" />
                            </div>
                        </div>
                    ) : null}
                    {newFlow && data.slider ? (
                        <AndroidDownloadNewFlow data={data} />
                    ) : (
                        <div className="row">
                            <div className="col-xs-12 text-center">
                                {data.title ? <h1>{data.title}</h1> : null}
                                {notSupported ? <p>{data.subtitle}</p> : null}
                                {oldFlow && supportedDevices.supportedDevices ? (
                                    <div role="presentation" onClick={() => this.onChange('Device Drawer')} className="supportSteps">
                                        <div className={drawerClass}>
                                            <ol>
                                                <li>
                                                    {supportedDevices.title}
                                                    <span>
                                                        {supportedDevices.btnText}
                                                        <i className="icon-arrow" />
                                                    </span>
                                                    <div
                                                        className="drawer"
                                                        dangerouslySetInnerHTML={{__html: supportedDevices.supportedDevices}}
                                                    />
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                ) : null}
                                {oldFlow ? settingMessage : null}
                                <div className="copy" dangerouslySetInnerHTML={{__html: data.description}} />
                            </div>
                        </div>
                    )}
                    <div className="row">
                        <div className="col-xs-12 text-center btnCta">
                            <a href={linkCTA} onClick={() => this.trackClick(buttonID)} className="btn btn-display no-animate">
                                {
                                    isAndroid && !notSupported ?
                                        <EGSDownloadImage locale={locale} theme="DARK" /> : <span>{data.ctaText}</span>
                                }
                            </a>
                        </div>
                        {data.openText ? (
                            <div className="col-xs-12 text-center">
                                <div className="copy spacing">
                                    <p>{data.openText}</p>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(AndroidDownload);
